<template>
  <PdfViewer :pdfUrl="pdfUrl"/>
</template>

<script>
// @ is an alias to /src
import PdfViewer from '@/components/PdfViewer.vue'

export default {
  name: 'PalworldModdingGuidelineView',
  components: {
    PdfViewer
  },
  inject: ['setTitle'],
  props: {
    lang: String
  },
  data() {
    return {
      pdfUrl: ""
    }
  },
  mounted() {
    this.setPdfUrl()
    this.setTitle(this.$t('app.title.palworldModdingGuideline'))
  },
  watch: {
    lang() {
      this.setPdfUrl()
      this.setTitle(this.$t('app.title.palworldModdingGuideline'))
    }
  },
  methods: {
    setPdfUrl() {
      const formattedLang = this.lang.replaceAll("_", "-")
      this.pdfUrl = `/guideline-pdf/palworld/mod_20260708_${formattedLang}.pdf`
    }
  }
}
</script>
